import { Typography } from "@mui/material";
import classNames from "classnames";

import styles from "./TopicLabel.module.css";

export interface TopicLabelProps {
  className?: classNames.Argument;
  dataType: string;
  label: string;
  match?: {
    position: [number, number];
  };
}

export function TopicLabel(props: TopicLabelProps) {
  const { className, dataType, label, match } = props;

  return (
    <div className={classNames(className, styles.labelContainer)}>
      <Label label={label} match={match} />
      <Typography
        className={classNames(
          styles.dataTypeLabel,
          styles.hideOverflow,
          styles.label,
        )}
        color="text.secondary"
      >
        {dataType}
      </Typography>
    </div>
  );
}

interface LabelProps {
  label: string;
  match?: {
    position: [number, number];
  };
}

export function Label({ label, match }: LabelProps) {
  if (match) {
    return (
      <p className={classNames(styles.hideOverflow, styles.label)}>
        {label.slice(0, match.position[0])}
        <span className={styles.highlight}>
          {label.slice(match.position[0], match.position[1])}
        </span>
        {label.slice(match.position[1])}
      </p>
    );
  }

  return (
    <p className={classNames(styles.hideOverflow, styles.label)}>{label}</p>
  );
}
